import { AppFunctionComponent } from "../../../types"
import React, { useEffect, useRef } from "react"
import { SubmenuItem } from "../../types/menu.interface"
import MobileAccordion from "../mobile-accordion/mobile-accordion.component"
import MobileCategoryWrapper from "../mobile-category-wrapper/mobile-category-wrapper.component"
import { MobileMenuElement, MobileSearchWrapper } from "./mobile-menu.styled"
import { SearchBoxInput } from "../../../components/common/search/search-box"
import styled from "styled-components"
import useTranslationHook from "../../../hooks/use-translation.hook"

interface Props {
  navigationItems: SubmenuItem[]
  opened: boolean
}

const StyledSearchBoxInput = styled(SearchBoxInput)`
  position: relative;
  width: 100%;
  margin: unset;
  padding: unset;
  flex: 1;
  border: none;
  form {
    margin: unset;
    justify-content: flex-end;
    input {
      border: none;
      padding: 0 2rem;
      width: 90vw;
    }
  }
  svg {
    padding: 0;
  }
`

const MobileMenu: AppFunctionComponent<Props> = ({
  className,
  opened = false,
  navigationItems,
}) => {
  const menu = useRef<HTMLDivElement>(null)
  const { translate } = useTranslationHook()

  const resize = () => {
    const menuElement = menu.current
    if (opened && menuElement && window) {
      const top = menuElement.getBoundingClientRect().top - 1
      menuElement.style.maxHeight = window.innerHeight - top + "px"
    }
  }

  useEffect(() => {
    if (opened) {
      resize()
      if (document) {
        document.addEventListener("scroll", resize)
      }
    }
    return () => {
      if (document) {
        document.removeEventListener("scroll", resize)
      }
    }
  }, [opened])

  return (
    <MobileMenuElement opened={opened} className={className} ref={menu}>
      {navigationItems.map((menuItem) => (
        <ul key={menuItem.displayName}>
          <MobileAccordion
            path={menuItem.path}
            displayName={menuItem.displayName}
            level={1}
          >
            {menuItem.subnavigationItem && (
              <MobileCategoryWrapper items={menuItem.subnavigationItem} />
            )}
          </MobileAccordion>
        </ul>
      ))}
      <ul>
        <MobileSearchWrapper
          level={1}
          isInput
          displayName={<StyledSearchBoxInput label={translate("Search")} />}
        ></MobileSearchWrapper>
      </ul>
    </MobileMenuElement>
  )
}

export default MobileMenu
